import { getNlsString } from '../../nls/nlsRuntime'
import type { NlsKey } from '../../nls/strings_nls'
import type { RecurringMode } from '../../types/recurringChecklist'

export type ChecklistNlsT = (key: NlsKey, values?: Record<string, string | number>) => string

export const defaultChecklistT: ChecklistNlsT = (key, values) => getNlsString(key, values, 'en')

export const getChecklistCadenceLabel = (t: ChecklistNlsT, mode: 'INDIVIDUAL' | RecurringMode): string => {
  if (mode === 'DAILY') return t('NLSChecklistKindDaily')
  if (mode === 'WEEKLY') return t('NLSChecklistKindWeekly')
  return t('NLSChecklistKindIndividual')
}

export const getChecklistOccurrenceTodayLabel = (t: ChecklistNlsT, mode: RecurringMode): string =>
  mode === 'WEEKLY' ? t('NLSChecklistOccurrenceThisWeek') : t('NLSChecklistOccurrenceToday')

export const getChecklistOccurrenceHistoryLabel = (t: ChecklistNlsT, mode: RecurringMode): string =>
  mode === 'WEEKLY' ? t('NLSChecklistOccurrenceWeeklyHistory') : t('NLSChecklistOccurrenceDailyHistory')

export const getChecklistCommentReactionLabel = (
  t: ChecklistNlsT,
  label: string,
  count: number,
): string =>
  count > 0
    ? t('NLSChecklistCommentReactionCount', { label, count })
    : t('NLSChecklistCommentReactionNoCount', { label })

export const getChecklistCompactLabels = (t: ChecklistNlsT) => ({
  tabs: [
    t('NLSChecklistKindIndividual'),
    t('NLSChecklistKindDaily'),
    t('NLSChecklistKindWeekly'),
  ],
  status: [
    t('NLSChecklistCardStatusDone'),
    t('NLSChecklistCardStatusOpen'),
    t('NLSChecklistStatusBlocked'),
    t('NLSChecklistStatusClear'),
  ],
  actions: [
    t('NLSChecklistActionSave'),
    t('NLSChecklistActionEdit'),
    t('NLSChecklistActionDiscard'),
    t('NLSChecklistActionReply'),
    t('NLSChecklistActionDelete'),
  ],
})
